import { Reactivation as ReactivationComponent } from '@ltvco/refresh-lib/payments';

export function Reactivation() {
  return (
    <div>
      <ReactivationComponent />
    </div>
  );
}
